<template>
  <div class="flashcard-deck">
    <div v-if="cards.length > 0 && currentIndex < cards.length">
      <Flashcard 
        :card="currentCard" 
      />
      <div class="navigation-buttons">
        <v-btn
          class="ns-btn-secondary"
          icon
          :elevation="0"
          :disabled="currentIndex >= cards.length" 
          @click="nextCardWordNotRemembered" 
        >
          <font-awesome-icon icon="xmark" />
        </v-btn>
        <span>{{ currentIndex + 1 }} / {{ cards.length }}</span>
        <v-btn
          class="ns-btn-primary"
          icon
          :elevation="0"
          :disabled="currentIndex >= cards.length" 
          @click="nextCardWordRemembered"
        >
          <font-awesome-icon icon="check" />
        </v-btn>
      </div>
    </div>
    <p v-else>
      You reviewed all the words for today! Great job! 🎉
    </p>
  </div>
</template>

<script>
import Flashcard from './FlashCard.vue';
import { patchWithAuthentication } from '@/services/api';
import { REVIEW_VOCABULARY_ENDPOINT, BASE_URL } from '@/assets/constants/api_endpoints.js';

export default {
  components: {
    Flashcard,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    currentCard() {
      return this.cards[this.currentIndex];
    },
  },
  methods: {
    async sendReviewStatus(id, correct) {
        const payload = {
          word_id: id.toString(),
          correct: correct.toString(),
        };
        const response = await patchWithAuthentication(
                                      BASE_URL, 
                                      REVIEW_VOCABULARY_ENDPOINT,
                                      payload
                                );
        if (response) {
          console.log('Review status updated successfully');
          console.log(response.data);
        } else { 
          console.error('Failed to update review status');
        }
    },
    async nextCardWordRemembered() {
      await this.sendReviewStatus(this.cards[this.currentIndex].id, true);
      if (this.currentIndex < this.cards.length) {
        this.currentIndex++;
      }
    },
    async nextCardWordNotRemembered() {
      await this.sendReviewStatus(this.cards[this.currentIndex].id, false);
      if (this.currentIndex < this.cards.length) {
        this.currentIndex++;
      }
    },
  },
};
</script>

<style scoped>
.flashcard-deck {
  text-align: center;
  padding: var(--space-5);
  background-color: var(--color-surface);
  border: 1px solid rgba(27,30,100,0.10);
  border-radius: var(--radius-lg);
  box-shadow: none;
  max-width: 600px;
  margin: var(--space-5) auto;
}

@media (max-width: 599px) {
  .flashcard-deck {
    max-width: 100%;
    width: calc(100vw - 20px);
    margin: var(--space-3) auto;
    padding: var(--space-3);
    box-sizing: border-box;
  }
}

.navigation-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-5);
  flex-wrap: wrap;
}

@media (max-width: 599px) {
  .navigation-buttons {
    gap: var(--space-2);
    margin-top: var(--space-4);
  }
}

.navigation-buttons .p-button {
  display: none;
}

.navigation-buttons span {
  font-size: var(--font-size-md);
  margin: 0 var(--space-4);
  color: var(--color-text-secondary);
  white-space: nowrap;
}

@media (max-width: 599px) {
  .navigation-buttons span {
    font-size: var(--font-size-base);
    margin: 0 var(--space-3);
  }
}

p {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  padding: var(--space-5);
}

@media (max-width: 599px) {
  p {
    font-size: var(--font-size-base);
    padding: var(--space-4);
  }
}
</style>